import {
  ArrowLeftOutlined,
  ArrowUpOutlined,
  CaretDownFilled,
  CaretUpFilled,
  PaperClipOutlined,
} from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Col,
  Divider,
  FloatButton,
  Form,
  Row,
  Space,
  Typography,
  theme,
} from "antd";
import { useForm } from "antd/es/form/Form";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Heading from "../../../components/common/heading";
import useCancelModal from "../../../lib/hooks/useCancelModal";

import { downloadFile } from "../../../services/uploadFile";

import { PAGES, PERMISSION_DATA } from "../../../lib/const";
import usePermission from "../../../lib/hooks/usePermisson";
import { routes } from "../../../routes";
import { getStakeholderCustomer } from "../../../services/customerStakeholder";
import WithSidebar from "../../../templates/withSidebar";
import { formatDateBE } from "../../../lib/utils/date";
import "./style.css";

const { useToken } = theme;

const { Text, Link } = Typography;

const style1 = {
  padding: 15,
  marginBottom: 20,
  width: "80%",
  border: "1px solid #E5EAEE",
  borderRadius: 10,
};
const style2 = {
  padding: 15,
  marginBottom: 20,
  width: "80%",
  border: "1px solid #E5EAEE",
  borderRadius: 10,
  height: "75px",
  overflow: "hidden",
};

const ViewStakeholder = () => {
  const navigate = useNavigate();
  const { token } = useToken();
  const params = useParams();
  const [roleUser] = usePermission(
    PERMISSION_DATA.APPLICATION,
    PAGES.STAKEHOLDER
  );
  const { setOpenCancelModal, setPreviousPage } = useCancelModal();

  const [form] = useForm();

  const [textT, setTextT] = useState([]);

  const [textK, setTextK] = useState([]);

  const [textOn, setTextOn] = useState([]);

  const [textOff, setTextOff] = useState([]);

  const [contactShowCSS, setContactShowCSS] = useState([]);
  console.log("contactShowCSS", contactShowCSS);

  const onChangePage = () => {
    setOpenCancelModal(true);
    setPreviousPage(routes.customer_tab_stakeholder);
  };

  const onFinish = (values) => {};

  const [stakeholdersContactPersonModel, setStakeholdersContactPersonModel] =
    useState();
  const [stakeholdersStaffFollowUpModels, setStakeholdersStaffFollowUpModels] =
    useState({});

  const [textCounty, setTextCounty] = useState([]);
  const [textPhone, setTextPhone] = useState([]);
  const [fileShow, setFileShow] = useState([]);
  const [dataDatail, setDataDatail] = useState();

  const stakeholderCustomer = useCallback(
    async (id) => {
      const res = await getStakeholderCustomer(id);
      if (res.data.code === "0000") {
        const { objectValue } = res.data;

        let showStaff = [];
        if (objectValue?.stakeholdersStaffFollowUpModels?.length > 0) {
          for (
            let a = 0;
            a < objectValue?.stakeholdersStaffFollowUpModels?.length;
            a++
          ) {
            showStaff.push({
              no: a,
              statusShow: true,
            });
          }
        }

        setContactShowCSS(showStaff);
        let arrCounty = [];
        let arrPhone = [];
        let files = [];
        if (objectValue?.stakeholdersStaffFollowUpModels?.length > 0) {
          for (
            let a = 0;
            a < objectValue?.stakeholdersStaffFollowUpModels?.length;
            a++
          ) {
            const res = await downloadFile(
              objectValue?.stakeholdersStaffFollowUpModels[a].filePath
            );

            files.push({
              index: a,
              file: res?.data?.objectValue?.fileName,
              fileName: res?.data?.objectValue?.fileName,
              filePath: res?.data?.objectValue?.filePath,
            });
          }
        }

        setFileShow(files);

        if (
          objectValue?.stakeholdersContactPersonModel?.contactPersonPhoneDetail
            .length > 0
        ) {
          for (
            let a = 0;
            a <
            objectValue?.stakeholdersContactPersonModel
              ?.contactPersonPhoneDetail.length;
            a++
          ) {
            arrPhone.push({
              phone:
                objectValue?.stakeholdersContactPersonModel
                  ?.contactPersonPhoneDetail[a].contactPhone,
            });
          }
        }

        if (
          objectValue?.stakeholdersContactPersonModel
            ?.contactPersonNationalityDetail.length > 0
        ) {
          for (
            let a = 0;
            a <
            objectValue?.stakeholdersContactPersonModel
              ?.contactPersonNationalityDetail.length;
            a++
          ) {
            arrCounty.push({
              countryNameEn:
                objectValue?.stakeholdersContactPersonModel
                  ?.contactPersonNationalityDetail[a].masterCountryDetail
                  ?.countryNameEn,
              countryNameTh:
                objectValue?.stakeholdersContactPersonModel
                  ?.contactPersonNationalityDetail[a].masterCountryDetail
                  ?.countryNameTh,
            });
          }
        }

        setTextCounty(arrCounty);
        setTextPhone(arrPhone);
        setDataDatail(objectValue);

        let arrTopic = [];
        let arrTopicText = [];

        if (objectValue?.stakeholdersTopicModels.length > 0) {
          for (
            let a = 0;
            a < objectValue?.stakeholdersContactPersonModel.length;
            a++
          ) {
            arrTopic.push({
              stakeholdersTopicId:
                objectValue?.stakeholdersTopicModels[a].stakeholdersTopicId,
              stakeholdersId:
                objectValue?.stakeholdersTopicModels[a].stakeholdersId,
              topicId: objectValue?.stakeholdersTopicModels[a].topicId,
              topicOther: objectValue?.stakeholdersTopicModels[a].topicOther,
            });
          }
        }
        if (objectValue?.stakeholdersTopicModels.length > 0) {
          for (
            let a = 0;
            a < objectValue?.stakeholdersTopicModels.length;
            a++
          ) {
            arrTopicText.push(
              objectValue?.stakeholdersTopicModels[a].masterDataDetail
                ?.dataDetailTh
            );
          }
        }

        let arrKnow = [];
        let arrKnowText = [];

        if (
          objectValue?.stakeholdersContactPersonModel
            ?.contactPersonReferredDetail.length > 0
        ) {
          for (
            let a = 0;
            a <
            objectValue?.stakeholdersContactPersonModel
              ?.contactPersonReferredDetail.length;
            a++
          ) {
            arrKnow.push({
              stakeholdersContactPersonReferredId:
                objectValue?.stakeholdersContactPersonModel
                  ?.contactPersonReferredDetail[a]
                  .stakeholdersContactPersonReferredId,
              stakeholdersContactPersonId:
                objectValue?.stakeholdersContactPersonModel
                  ?.contactPersonReferredDetail[a].stakeholdersContactPersonId,
              referredById:
                objectValue?.stakeholdersContactPersonModel
                  ?.contactPersonReferredDetail[a].referredById,
              referredByOther:
                objectValue?.stakeholdersContactPersonModel
                  ?.contactPersonReferredDetail[a].referredByOther,
            });
          }
        }
        if (
          objectValue?.stakeholdersContactPersonModel
            ?.contactPersonReferredDetail.length > 0
        ) {
          for (
            let a = 0;
            a <
            objectValue?.stakeholdersContactPersonModel
              ?.contactPersonReferredDetail.length;
            a++
          ) {
            arrKnowText.push(
              objectValue?.stakeholdersContactPersonModel
                ?.contactPersonReferredDetail[a].masterDataDetail?.dataDetailTh
            );
          }
        }

        let arrOn = [];
        let arrOnText = [];

        if (
          objectValue?.stakeholdersContactPersonModel
            ?.contactPersonPreferenceOnlineDetail.length > 0
        ) {
          for (
            let a = 0;
            a <
            objectValue?.stakeholdersContactPersonModel
              ?.contactPersonPreferenceOnlineDetail.length;
            a++
          ) {
            arrOn.push({
              stakeholdersContactPersonPreferenceOnlineId:
                objectValue?.stakeholdersContactPersonModel
                  ?.contactPersonPreferenceOnlineDetail[a]
                  .stakeholdersContactPersonPreferenceOnlineId,
              stakeholdersContactPersonId:
                objectValue?.stakeholdersContactPersonModel
                  ?.contactPersonPreferenceOnlineDetail[a]
                  .stakeholdersContactPersonId,
              contactPreferenceOnlineId:
                objectValue?.stakeholdersContactPersonModel
                  ?.contactPersonPreferenceOnlineDetail[a]
                  .contactPreferenceOnlineId,
              contactPreferenceOnlineOther:
                objectValue?.stakeholdersContactPersonModel
                  ?.contactPersonPreferenceOnlineDetail[a]
                  .contactPreferenceOnlineOther,
            });
          }
        }
        if (
          objectValue?.stakeholdersContactPersonModel
            ?.contactPersonPreferenceOnlineDetail.length > 0
        ) {
          for (
            let a = 0;
            a <
            objectValue?.stakeholdersContactPersonModel
              ?.contactPersonPreferenceOnlineDetail.length;
            a++
          ) {
            arrOnText.push(
              objectValue?.stakeholdersContactPersonModel
                ?.contactPersonPreferenceOnlineDetail[a].masterDataDetail
                ?.dataDetailTh
            );
          }
        }

        let arrOff = [];
        let arrOffText = [];

        if (
          objectValue?.stakeholdersContactPersonModel
            ?.contactPersonPreferenceOfflineDetail.length > 0
        ) {
          for (
            let a = 0;
            a <
            objectValue?.stakeholdersContactPersonModel
              ?.contactPersonPreferenceOfflineDetail.length;
            a++
          ) {
            arrOff.push({
              stakeholdersContactPersonPreferenceOfflineId:
                objectValue?.stakeholdersContactPersonModel
                  ?.contactPersonPreferenceOfflineDetail[a]
                  .stakeholdersContactPersonReferredId,
              stakeholdersContactPersonId:
                objectValue?.stakeholdersContactPersonModel
                  ?.contactPersonPreferenceOfflineDetail[a]
                  .stakeholdersContactPersonId,
              contactPreferenceOfflineId:
                objectValue?.stakeholdersContactPersonModel
                  ?.contactPersonPreferenceOfflineDetail[a].referredById,
              contactPreferenceOfflineOther:
                objectValue?.stakeholdersContactPersonModel
                  ?.contactPersonPreferenceOfflineDetail[a]
                  .contactPreferenceOfflineOther,
            });
          }
        }
        if (
          objectValue?.stakeholdersContactPersonModel
            ?.contactPersonPreferenceOfflineDetail.length > 0
        ) {
          for (
            let a = 0;
            a <
            objectValue?.stakeholdersContactPersonModel
              ?.contactPersonPreferenceOfflineDetail.length;
            a++
          ) {
            arrOffText.push(
              objectValue?.stakeholdersContactPersonModel
                ?.contactPersonPreferenceOfflineDetail[a].masterDataDetail
                ?.dataDetailTh
            );
          }
        }

        form.setFieldsValue({
          topicList: arrTopicText,
          knownChannel: arrKnowText,
          knownChannelOnline: arrOnText,
          knownChannelOffline: arrOffText,
        });

        setTextK(arrKnowText);

        setTextT(arrTopicText);

        setTextOn(arrOnText);

        setTextOff(arrOffText);

        form.setFieldsValue({
          stakeholdersId: objectValue?.stakeholdersId,
          yearOfBudget: objectValue?.yearOfBudget,
          customerDate: objectValue?.customerDate,
          customerType: objectValue?.customerType,
          stakeholdersCompanyId: objectValue?.stakeholdersCompanyId,
          stakeholdersContactPersonId: objectValue?.stakeholdersContactPersonId,
          createBy: objectValue?.createBy,
          createDate: objectValue?.createDate,
          updateBy: objectValue?.updateBy,
          updateDate: objectValue?.updateDate,
          typeOfEstate: objectValue?.typeOfEstate,
        });

        setStakeholdersContactPersonModel(
          objectValue?.stakeholdersContactPersonModel
        );
        setStakeholdersStaffFollowUpModels(
          objectValue?.stakeholdersStaffFollowUpModels
        );
        // if (objectValue?.stakeholdersStaffFollowUpModels.length > 0) {
        //   for (
        //     let a = 0;
        //     a < objectValue?.stakeholdersStaffFollowUpModels.length;
        //     a++
        //   ) {
        //     setContactShowCSS([
        //       ...contactShowCSS,
        //       { no: contactShowCSS.length + 1, statusShow: false },
        //     ]);
        //   }
        // }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [form]
  );

  useEffect(() => {
    stakeholderCustomer(params.id);
  }, [params.id, stakeholderCustomer]);

  const DownloadFile = async (fileName) => {
    const res = await downloadFile(fileName);

    if (
      res.headers["content-type"] === "application/octet-stream" ||
      res.headers["content-type"] === "application/pdf"
    ) {
      // for pdf type
      const blobFile = new Blob([res.data], {
        type: "application/pdf",
      });
      const href = URL.createObjectURL(blobFile);
      const downloadLink = document.createElement("a");
      downloadLink.href = href;
      downloadLink.download = fileName;
      document.body.appendChild(downloadLink);
      downloadLink.click();
    } else {
      // for image type
      const { objectValue } = res.data;
      if (objectValue) {
        const href = `${
          "data:" + res.headers["content-type"] + ";base64," + objectValue.bytes
        }`;
        const downloadLink = document.createElement("a");
        downloadLink.href = href;
        downloadLink.download = objectValue.fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
      }
    }
  };

  const collapseElems = (id) => {
    console.log("00000");
    const newState = contactShowCSS.map((obj) => {
      // 👇️ if id equals 2, update country property
      if (obj.no === id) {
        return { ...obj, statusShow: !obj.statusShow };
      }

      // 👇️ otherwise return the object as is
      return obj;
    });

    setContactShowCSS(newState);
  };

  return (
    <WithSidebar>
      <div>
        <FloatButton.BackTop
          className="custom-float-btn"
          icon={<ArrowUpOutlined style={{ color: "#fff" }} />}
          shape="square"
          style={{ backgroundColor: "#499D96 !important", color: "#fff" }}
        />
        <Row gutter={[24, 24]} style={{ marginTop: 15 }}>
          <Col span={24}>
            <div className="flex items-center">
              <Space size={12}>
                <Button
                  type="link"
                  onClick={onChangePage}
                  style={{ padding: 0 }}
                >
                  <ArrowLeftOutlined style={{ color: "#000", fontSize: 16 }} />
                </Button>
                <Heading text={"รายละเอียด"} size={4} style={{ margin: 0 }} />
              </Space>
            </div>
            <Breadcrumb
              style={{ paddingTop: 10 }}
              items={[
                {
                  title: "ผู้มีส่วนได้ส่วนเสีย",
                },
                {
                  title: <span className="pr_green">รายละเอียด</span>,
                },
              ]}
            />
          </Col>

          <Col span={24}>
            <Form
              form={form}
              onFinish={onFinish}
              layout="vertical"
              style={{ width: "100%", padding: "0 30px" }}
            >
              <Row gutter={[24, 16]} style={{ marginBottom: 10 }}>
                <Col span={24} align="right">
                  {roleUser[0]?.isEdit && (
                    <Button
                      type="primary"
                      onClick={() =>
                        navigate(
                          routes.edit_customer_stakeholder + "/" + params.id
                        )
                      }
                    >
                      แก้ไข
                    </Button>
                  )}
                </Col>
              </Row>

              <Row gutter={[24, 16]} className="card">
                <Col span={24}>
                  <Heading
                    text="ข้อมูลผู้มีส่วนได้ส่วนเสีย"
                    size={4}
                    style={{ margin: 0, color: token.thPrimary }}
                  />
                  <Divider />
                </Col>

                <Col className="gutter-row" span={8}>
                  <Form.Item label="ปีงบประมาณ" className="view-label">
                    {dataDatail?.yearOfBudget}
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={8}>
                  <Form.Item
                    label="วัน/เดือน/ปี ที่รับลูกค้า"
                    className="view-label"
                  >
                    {formatDateBE(new Date(dataDatail?.customerDate))}
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Row gutter={[16, 24]}>
                    <Col className="gutter-row" span={12}>
                      <Form.Item label="ประเภทผู้ติดต่อ" className="view-label">
                        {dataDatail?.customerType}
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>

                <Col className="gutter-row" span={16}>
                  <Form.Item
                    label="ประเด็นติดต่อต่าง ๆ (ตอบได้มากกว่า 1 ข้อ)"
                    className="view-label"
                  >
                    <Text>{textT.join(", ")}</Text>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[24, 16]} className="card" style={{ marginTop: 15 }}>
                <Col span={24}>
                  <Heading
                    text="ข้อมูลบริษัท"
                    size={4}
                    style={{ margin: 0, color: token.thPrimary }}
                  />
                  <Divider />
                </Col>

                <Col className="gutter-row" span={16}>
                  <Form.Item label="ชื่อบริษัท (TH)" className="view-label">
                    <label>
                      {dataDatail?.stakeholdersCompanyModel?.companyNameTH}
                    </label>
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={16}>
                  <Form.Item label="ชื่อบริษัท (EN)" className="view-label">
                    {dataDatail?.stakeholdersCompanyModel?.companyNameEN}
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={16}>
                  <Form.Item label="ที่อยู่บริษัท" className="view-label">
                    {dataDatail?.stakeholdersCompanyModel?.companyAddress}
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Row gutter={[16, 24]}>
                    <Col className="gutter-row" span={12}>
                      <Form.Item label="Email บริษัท" className="view-label">
                        {dataDatail?.stakeholdersCompanyModel?.companyEmail}
                      </Form.Item>
                    </Col>

                    <Col className="gutter-row" span={12}>
                      <Form.Item
                        label="เบอร์โทรศัพท์ผู้ติดต่อ"
                        className="view-label"
                      >
                        {dataDatail?.stakeholdersCompanyModel?.companyPhone}
                      </Form.Item>
                    </Col>

                    <Col className="gutter-row" span={12}>
                      <Form.Item label="Website" className="view-label">
                        <a
                          href={
                            dataDatail?.stakeholdersCompanyModel?.companyWebsite
                          }
                          target="_blank"
                          rel="noreferrer"
                        >
                          {dataDatail?.stakeholdersCompanyModel?.companyWebsite}
                        </a>
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row gutter={[24, 16]} className="card" style={{ marginTop: 15 }}>
                <Col span={24}>
                  <Heading
                    text={"ข้อมูลผู้ติดต่อ (Contact Person)"}
                    size={4}
                    style={{ margin: 0, color: token.thPrimary }}
                  />
                  <Divider />
                </Col>

                <Col className="gutter-row" span={8}>
                  <Form.Item label="ชื่อ-นามสกุล" className="view-label">
                    {dataDatail?.stakeholdersContactPersonModel?.contactName}
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={8}>
                  <Form.Item label="ตำแหน่ง" className="view-label">
                    {
                      dataDatail?.stakeholdersContactPersonModel
                        ?.contactPosition
                    }
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Row gutter={[16, 16]}>
                    <Col className="gutter-row" span={8}>
                      <Form.Item label="Email บริษัท" className="view-label">
                        {
                          dataDatail?.stakeholdersContactPersonModel
                            ?.contactEmail
                        }
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>

                <Col span={24}>
                  <Row gutter={[16, 16]}>
                    <Col className="gutter-row" span={8}>
                      <Form.Item
                        label="เบอร์โทรศัพท์ผู้ติดต่อ"
                        className="view-label"
                      >
                        {textPhone?.map((item, i) => {
                          return (
                            <>
                              <Text>{item ? item?.phone : "-"}</Text>
                              <br />
                            </>
                          );
                        })}
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>

                <Col span={24}>
                  <Row gutter={[16, 16]}>
                    <Col className="gutter-row" span={16}>
                      <Form.Item
                        label="สัญชาติ (ตอบได้มากกว่า 1 ข้อ)"
                        className="view-label"
                      >
                        {textCounty?.map((item, i) => {
                          return (
                            <>
                              <Text>{item ? item?.countryNameTh : "-"}</Text>
                              <br />
                            </>
                          );
                        })}
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>

                <Col className="gutter-row" span={16}>
                  <Form.Item
                    label="พื้นที่นิคมฯที่สนใจ/กนอ. แนะนำ"
                    className="view-label"
                  >
                    <Text>
                      {
                        dataDatail?.stakeholdersContactPersonModel
                          ?.areaAuthoritySuggested
                      }
                    </Text>
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={16}>
                  <Form.Item
                    label="ความต้องการ/ความคาดหวัง/ความพึงพอใจต่อผลิตภัณฑ์"
                    className="view-label"
                  >
                    <Text>
                      {
                        dataDatail?.stakeholdersContactPersonModel
                          ?.needsSatisfaction
                      }
                    </Text>
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={16}>
                  <Form.Item
                    label="ช่องทางที่รู้จัก กนอ. (ตอบได้มากกว่า 1 ข้อ)"
                    className="view-label"
                  >
                    <Text>{textK.join(", ")}</Text>
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={16}>
                  <Form.Item
                    label="ช่องทางที่ใช้ติดต่อ กนอ. ONLINE (ตอบได้มากกว่า 1 ข้อ)"
                    className="view-label"
                    name="contactPreferenceOnlineId "
                  >
                    <Text>{textOn.join(", ")}</Text>
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={16}>
                  <Form.Item
                    label="ช่องทางที่ใข้ติดต่อ กนอ. OFFLINE (ตอบได้มากกว่า 1 ข้อ)"
                    className="view-label"
                    name="contactPreferenceOfflineId"
                  >
                    <Text>{textOff.join(", ")}</Text>
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={16}>
                  <Form.Item label="พื้นที่ที่สนใจ" className="view-label">
                    <Text>
                      {stakeholdersContactPersonModel?.interestedArea}
                    </Text>
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={16}>
                  <Form.Item
                    label="ความต้องการ/ความคาดหวัง/VOC"
                    className="view-label"
                  >
                    <Text>
                      {
                        stakeholdersContactPersonModel?.requirementExpectationVoc
                      }
                    </Text>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[24, 16]} className="card" style={{ marginTop: 15 }}>
                <Col span={24}>
                  <Heading
                    text={"สรุปการติดต่อรายครั้ง"}
                    size={4}
                    style={{ margin: 0, color: token.thPrimary }}
                  />
                  <Divider />
                </Col>

                {stakeholdersStaffFollowUpModels.length > 0 &&
                  stakeholdersStaffFollowUpModels.map((item, index) => {
                    return (
                      <>
                        <Col key={index} span={24}>
                          <div
                            style={{
                              position: "absolute",
                              right: "120px",
                              bottom: "25px",
                            }}
                          >
                            <Button
                              shape="circle"
                              size="small"
                              style={{
                                backgroundColor: "#F4F6FC",
                                border: 0,
                                marginLeft: 5,
                              }}
                              onClick={() => collapseElems(index)}
                            >
                              {!contactShowCSS[index].statusShow ? (
                                <CaretUpFilled
                                  style={{
                                    color: "#2E90FA",
                                    fontSize: 16,
                                  }}
                                />
                              ) : (
                                <CaretDownFilled
                                  style={{
                                    color: "#2E90FA",
                                    fontSize: 16,
                                  }}
                                />
                              )}
                            </Button>
                          </div>
                          <div
                            className={`relative`}
                            style={
                              contactShowCSS[index].statusShow === true
                                ? style2
                                : style1
                            }
                          >
                            <Row gutter={[24, 16]}>
                              <Col className="gutter-row" span={8}>
                                <Form.Item
                                  label="วัน/เดือน/ปี ที่ติดต่อ"
                                  className="view-label"
                                >
                                  <Text
                                    style={{
                                      marginTop: "-15px",
                                      position: "absolute",
                                    }}
                                  >
                                    {formatDateBE(new Date(item.contactDate))}
                                  </Text>
                                </Form.Item>
                              </Col>
                              <Col className="gutter-row" span={8}>
                                <Form.Item
                                  label="ชื่อเจ้าหน้าที่"
                                  className="view-label"
                                >
                                  <Text
                                    style={{
                                      marginTop: "-15px",
                                      // position: "absolute",
                                    }}
                                  >
                                    {item.staffName}
                                  </Text>
                                </Form.Item>
                              </Col>
                            </Row>

                            <Row gutter={[24, 16]}>
                              {" "}
                              <Col className="gutter-row" span={24}>
                                <Form.Item
                                  label="รายละเอียดการติดต่อ"
                                  className="view-label"
                                >
                                  <Text
                                    style={{
                                      marginTop: "-15px",
                                      // position: "absolute",
                                    }}
                                  >
                                    {item.staffDetail}
                                  </Text>
                                </Form.Item>
                              </Col>
                            </Row>

                            <Row gutter={[24, 16]}>
                              <Col className="gutter-row" span={24}>
                                <Form.Item
                                  label="แนบไฟล์"
                                  name=""
                                  className="view-label"
                                  rules={[
                                    { required: true, message: "โปรดระบุ" },
                                  ]}
                                >
                                  <Link
                                    style={{
                                      marginTop: "-15px",
                                      position: "absolute",
                                    }}
                                    onClick={() =>
                                      DownloadFile(fileShow[index].filePath)
                                    }
                                    underline
                                  >
                                    <PaperClipOutlined
                                      style={{ paddingRight: 5 }}
                                    />

                                    {fileShow[index].fileName}
                                  </Link>
                                </Form.Item>
                              </Col>
                            </Row>

                            <Row gutter={[24, 16]}>
                              <Col className="gutter-row" span={24}>
                                <Form.Item label="Note" className="view-label">
                                  <Text
                                    style={{
                                      marginTop: "-15px",
                                      position: "absolute",
                                    }}
                                  >
                                    {item.staffFollowUp}
                                  </Text>
                                </Form.Item>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                      </>
                    );
                  })}
              </Row>
            </Form>
          </Col>
        </Row>
      </div>
    </WithSidebar>
  );
};

export default ViewStakeholder;
